import css from './sass/style.scss';

require('./js/agenda.js');
require('./js/anims.js');
require('./js/carousels.js');
require('./js/helpers.js');
require('./js/mobile-detach.js');
require('./js/polyfills.js');
require('./js/init.js');
require('./js/ismobile.js');
require('./js/lazy.js');
require('./js/nav.js');
require('./js/news-ticker.js');
require('./js/smoothscroll.js');

